import React from 'react'
import { Router } from 'react-router'
import { Provider } from 'react-redux'
import ReactDOM from 'react-dom'

import registerServiceWorker from './registerServiceWorker'
import setupApp from './setupApp'
import './bootstrap'
import routes from './routes'

const root = () =>
  setupApp().then(({ store, history }) => {
    ReactDOM.render(
      <Provider store={store}>
        <Router history={history} routes={routes(store)} />
      </Provider>,
      document.getElementById('root')
    )
    registerServiceWorker()
  })

root()



// WEBPACK FOOTER //
// ./src/index.js